import { boxCustomisationConfig } from './box-customisation-config.hook';
import { boxCustomisationProduce } from './box-customisation-produce.hook';
import { deliveryConfiguration } from './delivery-configuration.hook';
import { packHouseInternal } from './pack-house.hook';
import { products } from './products.hook';
import { salesAddons } from './sales-addon.hook';

export const packHouse = {
    ...packHouseInternal,
    ...products,
    ...deliveryConfiguration,
    ...salesAddons,
    ...boxCustomisationProduce,
    ...boxCustomisationConfig,
};
